import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';

import { DataFormatterModule } from 'tis-data-formatter';

import { CoreModule } from '@core/core.module';
import { AppRoutingModule } from './app-routing.module';

import {
	TranslateLoader,
    TranslateModule
} from '@ngx-translate/core';

import { AppConfig } from '@root/app.config';
import {
    HttpLoaderFactory,
	appConfigProviderFactory
} from '@root/app.module.extras';

import { SharedModule } from '@shared/shared.module';
import { DateFormatService } from '@shared/date-format/date-format.service';

import { AppComponent } from './app.component';
import { FullPageLoaderModule } from './modules/shared/full-page-loader/full-page-loader.module';
import { AlertModule } from './modules/core/alert/alert.module';
import { RouterModule } from '@angular/router';

@NgModule({

	imports: [
		SharedModule,
		CoreModule,
		BrowserModule,
		HttpClientModule,
		OverlayModule,
		AppRoutingModule,
		DataFormatterModule.forRoot(),
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
		NgxPermissionsModule.forRoot(),
		FullPageLoaderModule,
		AlertModule,
		RouterModule,
	],
	declarations: [AppComponent],
	providers: [
		DateFormatService,
		AppConfig,
		{
			provide: APP_INITIALIZER,
			useFactory: appConfigProviderFactory,
			deps: [
				AppConfig,
				NgxPermissionsService
			],
			multi: true
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
